import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-information-sidebar-feedback-external',
  templateUrl: './information-sidebar-feedback-external.component.html',
  styleUrls: ['./information-sidebar-feedback-external.component.scss']
})
export class InformationSidebarFeedbackExternalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
